// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"97167b0e","80":"fc0ac416","310":"b690eccf","325":"ac82336a","411":"d539433e","529":"07d20a10","623":"ae857522","699":"c93c58d4","715":"ce02e8b1","892":"1db78500"}[chunkId] + ".chunk.js";
};